import { GameSession } from "../../GameSession";
import { DiamondSpinState } from "./DiamondSpinState";
// holds values of freegame
export class DiamondSpinSession extends GameSession
{
	
	public state: DiamondSpinState = DiamondSpinState.Idle;
	public startingSpins:number = 0;
	public remainingSpins: number = 0;
	public playedSpins: number = 0;
	public totalWin: number =0;

	constructor() {
		super();
	} 

	public static FromValues(state: DiamondSpinState, totalWin:number, startingSpins:number, remainingSpins: number, playedSpins: number): DiamondSpinSession {
		
		let dss = new DiamondSpinSession();

		dss.state = state;
		dss.startingSpins = startingSpins;
		dss.remainingSpins = remainingSpins;
		dss.playedSpins = playedSpins;
		dss.totalWin = totalWin;

		return dss;
	}

	public Reset(): void
	{
		this.totalWin = 0 ;
		this.startingSpins = 0;
		this.remainingSpins = 0;
		this.playedSpins = 0;
	}

	public Update(newSession: DiamondSpinSession)
	{
		this.startingSpins = newSession.startingSpins;
		this.remainingSpins = newSession.remainingSpins;
		this.playedSpins = newSession.playedSpins;
		this.totalWin = newSession.totalWin;
	}
}